// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueAnalytics from 'vue-analytics'
import VueCookie from 'vue-cookie'
import VueScrollTo from 'vue-scrollto'
import VueWaypoint from 'vue-waypoint'
import VueLazyload from 'vue-lazyload'
import VueHead from 'vue-head'
import VueMq from 'vue-mq'
import autofocus from 'vue-autofocus-directive'

Vue.config.productionTip = false
Vue.directive('autofocus', autofocus)
Vue.use(VueScrollTo)
Vue.use(VueCookie)
Vue.use(VueWaypoint)
Vue.use(VueHead)
Vue.use(VueLazyload, {
  preLoad: 2
})
Vue.use(VueMq, {
  breakpoints: {
    sm: 450,
    md: 1024,
    lg: Infinity
  }
})
Vue.use(VueAnalytics, {
  id: 'UA-30609807-6',
  router
})

Vue.mixin({
  methods: {
    scrollToVideos: function () {
      this.$nextTick()
        .then(() => {
          if (document.getElementById('video-thumbnails') !== null) {
            document.getElementById('video-thumbnails').scrollIntoView(true)
            window.scroll(0, window.scrollY - 48)
          }
        })
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js